import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatConversationUtilityClass(slot) {
  return generateUtilityClass('MuiChatConversation', slot);
}
export const chatConversationClasses = generateUtilityClasses('MuiChatConversation', ['root', 'header', 'headerInfo', 'title', 'subtitle', 'headerActions']);
const slots = {
  root: ['root'],
  header: ['header'],
  headerInfo: ['headerInfo'],
  title: ['title'],
  subtitle: ['subtitle'],
  headerActions: ['headerActions']
};
export const useChatConversationUtilityClasses = classes => composeClasses(slots, getChatConversationUtilityClass, classes);